<div class="addContainer">
  <form [formGroup]="form">
    <!--  <small>Name</small>-->
    <input class="input-item" formControlName="name" id="name" placeholder="Collection Name">
    <button (mousedown)="addNewItem($event)" [disabled]="form.invalid">Add</button>
  </form>
</div>
